<template lang="pug">
.facsimile-bundle(v-if="bundle" v-observe-visibility="visibilityChanged")
  h2 {{ $t('bundle.bundle') }}&#0032;
    span.has-text-weight-light {{ $t('bundle.for') }} »{{ bundle.title }}«
  section-switch(:withsearchresults="true")
  hr
  slick.carousel(ref="slick" :options="slickOptions" data-slick="slickOptions")
    div(v-if="bundle.bundle.length === 0") {{ $t('bundle.empty') }}
    div(v-else v-for="(f, index) in bundle.bundle")
      .card(v-waypoint="endOfBundle(index)" :id="'bundle_' + f.id" :class="{ 'is-active': currentPage && f.id === currentPage.id } ")
        .card-image
          figure
            a(v-if="f.available" @click="routeAndClose(f)")
              img(:src="imgSrc(f)")
            div(v-else)
              .image.missing
        .card-content
          .content.has-text-centered
            span {{ f.title }}
            br
            span {{ f.sig }}
            br
            span(v-if="!f.available") {{ $t('bundle.notAvailable') }}
            span(v-else) &#160;
</template>

<script>
import SectionSwitch from "./SectionSwitch";
import Slick from "vue-slick";

const toc = require("../toc");
const { mapActions, mapGetters, mapState } = require("vuex");
const { messages } = require("../i18n/facsimile-bundle");
const paddingInPixels = 25;

export default {
    components: {
        SectionSwitch,
        Slick,
    },
    name: "FacsimileBundle",
    i18n: { messages },

    data() {
        return {
            slickOptions: {
                dots: true,
                nextArrow:
                    "<button class='button slick-next slick-arrow'><i class='fa fa-angle-right'/></button>",
                prevArrow:
                    "<button class='button slick-prev slick-arrow'><i class='fa fa-angle-left'/></button>",
                //draggable: true,
                infinite: false,
                slidesToScroll: 4,
                //slidesToShow: 3,
                //speed: 800,
                //swipe: true,
                variableWidth: true,
            },
        };
    },

    computed: {
        bundle() {
            if (this.isSearchContext) {
                const adHocResultBundle = this.results.map((r) => {
                    return {
                        available: true,
                        id: r.id,
                        sig: "",
                        textBoundingBox: {},
                        title: Array.isArray(r.title) ? r.title[0] : r.title,
                    };
                });
                const title =
                    "Suchergebnisse" +
                    (this.routeQuery && this.routeQuery.q
                        ? " für " + this.routeQuery.q
                        : "");
                return { bundle: adHocResultBundle, title };
            } else if (this.isWatchlistContext) {
                const adHocResultBundle = Object.keys(this.watchlist).map(
                    (i) => {
                        return {
                            available: true,
                            id: this.watchlist[i].id,
                            sig: "",
                            textBoundingBox: {},
                            title: Array.isArray(this.watchlist[i].title)
                                ? this.watchlist[i].title[0]
                                : this.watchlist[i].title,
                        };
                    }
                );
                const title = "Merkliste";
                return { bundle: adHocResultBundle, title };
            } else if (this.$route.name == "transcript") {
                return toc.facsimileBundle(this.$route);
            } else {
                return undefined;
            }
        },

        indexOfCurrentPage() {
            if (this.bundle.bundle) {
                return this.bundle.bundle.findIndex((f) => {
                    return f.id === this.currentPage.id;
                });
            } else {
                return -1;
            }
        },

        isSearchContext() {
            return this.$route.params.section === "suche";
        },

        isWatchlistContext() {
            return this.$route.params.section === "merkliste";
        },

        section() {
            return this.$route.params.section;
        },

        ...mapGetters("toc", { currentPage: "current" }),
        ...mapState("search", [
            "results",
            "routeQuery",
            "total",
            "transactions",
        ]),
        ...mapState("transcript", ["watchlist"]),
    },

    methods: {
        endOfBundle(index) {
            const nextQuery = this.nextQuery.bind(this);
            const active =
                this.section === "suche" &&
                this.transactions === 0 &&
                index === this.bundle.bundle.length - 1;

            return {
                active,

                callback: function ({ going, direction }) {
                    if (direction == "right" && going == "in") {
                        nextQuery();
                    }
                },

                options: {
                    root:
                        this.$el instanceof Element ? this.$el : document.body,
                },
            };
        },

        imgSrc({ id }) {
            let pbr = getPageBoundingRect(this.section, id);
            pbr = boundingRectToPaddedIiifRegion(pbr);
            let region = pbr ? `${pbr.x},${pbr.y},${pbr.w},${pbr.h}` : "full";
            return `/iiif/3/${id}/${region}/!500,500/0/default.jpg`;
        },

        pathToPage({ id }) {
            return `/seite/${this.section}/${id}`;
        },

        routeAndClose(f) {
            // close modal, if it was open
            document.querySelector(".modal-close")?.click();
            const requestedPagePath = this.pathToPage(f);

            if (requestedPagePath != this.$route.path) {
                this.$router.push(requestedPagePath);
            }
        },

        visibilityChanged(isVisible) {
            if (isVisible) {
                this.$refs.slick.goTo(this.indexOfCurrentPage);
            }
        },

        ...mapActions("search", ["nextQuery"]),
    },

    watch: {
        bundle: function (newBundle, oldBundle) {
            if (oldBundle && newBundle && newBundle.title != oldBundle.title) {
                reSlick(this, null);
            } else if (oldBundle && newBundle) {
                const index =
                    newBundle.bundle.length > oldBundle.bundle.length
                        ? this.$refs.slick.currentSlide()
                        : 0;
                reSlick(this, index);
            } else {
                reSlick(this, null);
            }
        },
    },
};

function boundingRectToPaddedIiifRegion(pageBoundingRect) {
    if (pageBoundingRect) {
        return {
            x: Math.max(0, pageBoundingRect.left - paddingInPixels),
            y: Math.max(0, pageBoundingRect.top - 5 * paddingInPixels),
            w: pageBoundingRect.right - pageBoundingRect.left + paddingInPixels,
            h:
                pageBoundingRect.bottom -
                pageBoundingRect.top +
                5 * paddingInPixels,
        };
    } else {
        return null;
    }
}

function getPageBoundingRect(section, id) {
    if (section === "suche" || section === "merkliste") {
        section = "edition";
    }
    const node = toc.node({ name: "transcript", params: { section, id } });
    const page = node.facsimiles.filter((f) => f.id == id)[0];
    return page.textBoundingBox;
}

function reSlick(vueComponent, index) {
    const slickDestroy = vueComponent.$refs.slick
        ? vueComponent.$refs.slick.destroy
        : () => {};
    const slickCreate = vueComponent.$refs.slick
        ? vueComponent.$refs.slick.create
        : () => {};
    const slickGoTo = vueComponent.$refs.slick
        ? vueComponent.$refs.slick.goTo
        : () => {};

    slickDestroy();

    vueComponent.$nextTick(() => {
        slickCreate();
        if (typeof index !== "undefined" && index !== null) {
            slickGoTo(index, true);
        }
    });
}
</script>
